function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { highArea_queryPage, getExcelPath, download, highArea_import, saveHighArea, deleteHighArea } from '@/api/baseDataManage';
import { getCompanyList } from '@/api/baseDate';
export default {
  name: 'heighRisk',
  data: function data() {
    return {
      fileList: [],
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        pageNo: 1,
        pageSize: 10,
        area: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        tbcHighRiskAreaId: '',
        type: '',
        areaCode: '',
        area: ''
      },
      markForm_new: {
        tbcHighRiskAreaId: '',
        type: '',
        areaCode: '',
        area: ''
      },
      countryrule: {
        areaCode: [{
          required: true,
          message: '请输入国家 / 地区代码',
          trigger: 'blur'
        }],
        area: [{
          required: true,
          message: '请输入国家 / 地区名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();
    });
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      highArea_queryPage(_objectSpread({}, this.form)).then(function (res) {
        _this2.loading = false;
        _this2.total = res.totalCount;
        _this2.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.area = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this3 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.new_edit = _this3.newumarBtn = false;

          _this3.openFullScreen();

          saveHighArea(data).then(function (res) {
            if (res.resultCode == '0000') {
              _this3.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this3.markForm_new) {
                _this3.markForm_new[key] = '';
              }

              _this3.getData();
            } else {
              _this3.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this3.screenLoading.close();

            _this3.markForm_new = {
              tbcHighRiskAreaId: '',
              type: '',
              areaCode: '',
              area: ''
            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.editData = data;
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }
    },
    // 删除
    dele: function dele(data) {
      var _this4 = this;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteHighArea({
          tbcHighRiskAreaId: data.tbcHighRiskAreaId
        }).then(function (res) {
          // console.log(res)
          if (res.resultCode == '0000') {
            _this4.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this4.getData();
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this5 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this5.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'highArea'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "高风险地区清单模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "高风险地区清单模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this6 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      highArea_import(dataFile).then(function (res) {
        _this6.screenLoading.close();

        if (res.resultCode == '0000') {
          _this6.$message({
            type: 'success',
            message: '导入成功'
          });

          _this6.getData();
        } else {
          _this6.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};